module.exports = __webpack_public_path__ + "img/vi.66a1745b.svg";